import moment from 'moment';

export function getDaterangeByPeriod(period) {
  const firstDayOfMonth = moment()
    .startOf('month');
  const firstDayOfWeek = moment()
    .startOf('week');
  const firstDayOfYear = moment()
    .startOf('year');
  const lastDayOfMonth = moment()
    .endOf('month');
  const lastDayOfWeek = moment()
    .endOf('week');
  const lastDayOfYear = moment()
    .endOf('year');
  const endOfDay = moment()
    .endOf('day');

  let start = new Date(); 
  let end = new Date();

  switch (period) {
    // all data
    case 2:
      start = moment(firstDayOfYear)
        .subtract(10, 'year');
      end = lastDayOfYear;
      break;
    // this week
    case 7:
      start = firstDayOfWeek;
      end = lastDayOfWeek;
      break;
    // Previous week
    case -70:
      start = moment(firstDayOfWeek)
        .subtract(1, 'week');
      end = moment(lastDayOfWeek)
        .subtract(1, 'week');
      break;
    // Last 7 days
    case -7:
      start = (() => {
        const d = new Date();
        d.setDate(d.getDate() - 6);
        return moment(d)
          .startOf('day');
      })();
      end = endOfDay;
      break;
    // Last 14 days
    case -14:
      start = (() => {
        const d = new Date();
        d.setDate(d.getDate() - 13);
        return moment(d)
          .startOf('day');
      })();
      end = endOfDay;
      break;
    // this month
    case 30:
      start = firstDayOfMonth;
      end = endOfDay;
      break;
    // Previous month
    case -30:
      start = moment(firstDayOfMonth)
        .subtract(1, 'months');
      end = moment()
        .subtract(1, 'months')
        .endOf('month');
      break;
    // last 30 days
    case 100:
      start = (() => {
        const d = new Date();
        d.setDate(d.getDate() - 29);
        return moment(d)
          .startOf('day');
      })();
      end = endOfDay;
      break;
    // this year
    case 365:
      start = firstDayOfYear;
      end = lastDayOfYear;
      break;
    // last year
    case -365:
      start = moment(firstDayOfYear)
        .subtract(1, 'year');
      end = moment(lastDayOfYear)
        .subtract(1, 'year');
      break;
    // last 365
    case -3650:
      start = (() => {
        const d = new Date();
        d.setDate(d.getDate() - 364);
        return moment(d)
          .startOf('day');
      })();
      end = endOfDay;
      break;
    default:
      start = firstDayOfMonth;
      end = lastDayOfMonth;
  }

  return {
    start: `${moment(start)
      .format('YYYY-MM-DD 00:00:00')}`, 
    end: `${moment(end)
      .format('YYYY-MM-DD 23:59:59')}`,
  };
}

export function fixRange(range) {
  if (!range) {
    return null;
  }

  const { from, to, period} = range;

  if (!period || period === 1) {
    return null;
  }

  let {start, end} = getDaterangeByPeriod(period);

  if (from !== start || to !== end) {
    return {
      from: start,
      to: end,
      period,
    };
  }

  return null;
}

export default {
  methods: {
    getDaterangeByPeriod,
    fixRange,
  },
};
